const groupAndSpreadMarkers = (
  campaigns: any[],
  spreadInMeters: number = 20
): any[] => {
  const grouped: Record<string, any[]> = {};

  // 1 degree ≈ 111_320 meters
  const spreadInDegrees = spreadInMeters / 111_320;

  // Group by identical lat/lng
  campaigns.forEach((item) => {
    const key = `${item.latitude},${item.longitude}`;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(item);
  });

  const spreadMarkers: any[] = [];

  // Spread overlapping markers
  Object.entries(grouped).forEach(([key, items]) => {
    const [latStr, lngStr] = key.split(',');
    const baseLat = parseFloat(latStr);
    const baseLng = parseFloat(lngStr);

    if (items.length === 1) {
      spreadMarkers.push({
        ...items[0],
        latitude: baseLat,
        longitude: baseLng,
      });
      return;
    }

    const count = items.length;
    items.forEach((item, index) => {
      const angle = (2 * Math.PI * index) / count;

      // Adjust longitude offset using latitude
      const offsetLat = spreadInDegrees * Math.sin(angle);
      const offsetLng =
        (spreadInDegrees * Math.cos(angle)) /
        Math.cos((baseLat * Math.PI) / 180);

      spreadMarkers.push({
        ...item,
        latitude: baseLat + offsetLat,
        longitude: baseLng + offsetLng,
      });
    });
  });

  return spreadMarkers;
};

export default groupAndSpreadMarkers;
